import { render, staticRenderFns } from "./CommunityWorkNewsCard.vue?vue&type=template&id=0c490b7c&scoped=true"
import script from "./CommunityWorkNewsCard.vue?vue&type=script&lang=js"
export * from "./CommunityWorkNewsCard.vue?vue&type=script&lang=js"
import style0 from "./CommunityWorkNewsCard.vue?vue&type=style&index=0&id=0c490b7c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c490b7c",
  null
  
)

export default component.exports